module.exports = __webpack_public_path__ + "media/flags/fo-004abd27.svg";